import type { DesktopEnvironmentBootstrapEnvelope } from "@cmmd-forge/contracts";

import {
  readRuntimeBridgeBootstrapEnvelope,
  setRuntimeBridgeBootstrapEnvelopeForTests,
} from "./runtimeBridge";

export const FORGE_LOCAL_WEB_ENVIRONMENT_BOOTSTRAP_KEY = "forge:local-web-environment-bootstrap:v1";

export function readEnvironmentBootstrapEnvelope(): DesktopEnvironmentBootstrapEnvelope | null {
  return readRuntimeBridgeBootstrapEnvelope();
}

export function writeLocalWebEnvironmentBootstrapEnvelope(
  envelope: DesktopEnvironmentBootstrapEnvelope | null,
): void {
  setRuntimeBridgeBootstrapEnvelopeForTests(envelope);
}
